import * as React from 'react'
import * as ItemTypes from '@disco/constants/ItemTypes'
import PlaylistDragPreview from '../playlist-drag-preview'
import TrackDragPreview from '../track-drag-preview'
import BriefDragPreview from '../brief-drag-preview'
import { SelectableItem } from '@disco/types/types/selection'

/**
 * Item drag preview component that renders appropriate preview based on item type
 * Routes to specific preview components for tracks and playlists during drag operations
 * @param item - Track or playlist item being dragged
 */
const ItemDragPreview = ({
  item,
}: {
  item: SelectableItem
}): null | React.ReactNode => {
  switch (item.type) {
    case ItemTypes.TRACK:
      return <TrackDragPreview track={item} />

    case ItemTypes.PLAYLIST:
      return <PlaylistDragPreview playlist={item} />

    case ItemTypes.BRIEF:
      return <BriefDragPreview brief={item} />

    default:
      return null
  }
}

export default ItemDragPreview
